module.exports = __webpack_public_path__ + "img/9791158882891.af46647b.jpg";